import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "components/Button";
import { Input } from "components/Input";
import { PageWithNav } from "components/PageWithNav";
import { TextEditor } from "components/TextEditor";
import api from "utils/api";
import { useToastContext } from "context/ToastContext";

export const CreateLesson = () => {
  const navigate = useNavigate();
  const { notify } = useToastContext();
  const [video, setVideo] = useState("");
  const [description, setDescription] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.set("description", description);

    try {
      setIsLoading(true);
      await api.post("/lesson", formData);
      setIsLoading(false);
      notify({ title: "Success", description: "Lesson added!", type: "success" });
      navigate("/lessons");
    } catch (e) {
      setIsLoading(false);
    }
  };

  return (
    <PageWithNav>
      <h1 className="mb-5 pe-4 text-xl font-semibold text-neutral-900">Create new course</h1>
      <form onSubmit={handleSubmit} data-testid="create-lesson-form">
        <Input id="name" name="name" type="text" required label="Lesson name" placeholder="f.e How to tint a car" />
        <Input id="video" value={video} onChange={(e) => setVideo(e.target.value)} name="video" type="text" required label="Lesson video" placeholder="https://gcs.video.mp4" />
        {video && (
          <div className="max-w-100 mx-auto my-4 flex items-center justify-center rounded-lg bg-gray-100 p-6 text-center">
            <video controls width="320" data-testid="video-player">
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
        <TextEditor value={description} onChange={setDescription} id="description" label="Lesson description" />
        <div className="my-4 flex gap-2">
          <Button disabled={isLoading} onClick={() => navigate("/lessons")} color="secondary" size="sm">
            Cancel
          </Button>
          <Button disabled={isLoading} loading={isLoading} type="submit" color="primary" size="sm">
            Save
          </Button>
        </div>
      </form>
    </PageWithNav>
  );
};
